import { cn } from "@/lib/utils";

interface ChatMessageProps {
	role: "user" | "bot";
	content: string;
}

export function ChatMessage({ role, content }: ChatMessageProps) {
	const isBot = role === "bot";

	return (
		<div
			className={cn(
				"flex w-full gap-2 mb-4",
				isBot ? "justify-start" : "justify-end",
			)}
		>
			{isBot && (
				<div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-xs font-semibold">
					AI
				</div>
			)}
			<div
				className={cn(
					"max-w-[80%] rounded-xl px-4 py-2.5 text-sm leading-relaxed",
					isBot
						? "bg-muted text-foreground rounded-tl-sm"
						: "bg-primary text-primary-foreground rounded-tr-sm",
				)}
			>
				{content.split("\n").map((line, i) => (
					<span key={`${line}-${String(i)}`}>
						{line}
						{i < content.split("\n").length - 1 && <br />}
					</span>
				))}
			</div>
			{!isBot && (
				<div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-foreground/10 text-foreground text-xs font-semibold">
					You
				</div>
			)}
		</div>
	);
}
